import SreReadingTracker from ".";

/**
 * Start reading tracker session
 * @param sessionId - sre session ID
 * @param text - text to track while reading
 * @param beginOfSpeechTimeout - in milliseconds
 * @param endOfSpeechTimeout - in milliseconds
 * @param useGrammar - whether to enable grammar parsing
 */
var startReadingTrackerSessionV2 = function startReadingTrackerSessionV2(_ref) {
  var sessionId = _ref.sessionId,
      text = _ref.text,
      beginOfSpeechTimeout = _ref.beginOfSpeechTimeout,
      endOfSpeechTimeout = _ref.endOfSpeechTimeout,
      _ref$useGrammar = _ref.useGrammar,
      useGrammar = _ref$useGrammar === undefined ? false : _ref$useGrammar;
  return {
    type: SreReadingTracker.READING_TRACKER_SESSION_START_V2,
    payload: {
      sessionId: sessionId,
      text: text,
      beginOfSpeechTimeout: beginOfSpeechTimeout,
      endOfSpeechTimeout: endOfSpeechTimeout,
      useGrammar: useGrammar
    }
  };
};

var readingTrackerSessionProgressV2 = function readingTrackerSessionProgressV2(_ref2) {
  var currentSpeakingWordIndex = _ref2.currentSpeakingWordIndex,
      isResultAvailable = _ref2.isResultAvailable;

  return {
    type: SreReadingTracker.READING_TRACKER_SESSION_PROGRESS_V2,
    payload: {
      currentSpeakingWordIndex: currentSpeakingWordIndex,
      isResultAvailable: isResultAvailable
    }
  };
};

var readingTrackerSessionReset = function readingTrackerSessionReset() {
  return {
    type: SreReadingTracker.READING_TRACKER_SESSION_RESET
  };
};

// Populates the reading tracker state with session data and final result.
var readingTrackerSessionResultV2 = function readingTrackerSessionResultV2(_ref3) {
  var finalResultExists = _ref3.finalResultExists,
      silenceDetected = _ref3.silenceDetected,
      error = _ref3.error,
      canceled = _ref3.canceled,
      gradedWords = _ref3.gradedWords,
      finalScore = _ref3.finalScore,
      hypothesis = _ref3.hypothesis;
  return {
    type: SreReadingTracker.READING_TRACKER_SESSION_RESULT_V2,
    payload: {
      finalResultExists: finalResultExists,
      silenceDetected: silenceDetected,
      error: error,
      canceled: canceled,
      gradedWords: gradedWords,
      finalScore: finalScore,
      hypothesis: hypothesis
    }
  };
};

// Store the sound in the readingtracker state for playback.
var readingTrackerSessionStoreSound = function readingTrackerSessionStoreSound(soundObj, soundLog) {
  return {
    type: SreReadingTracker.READING_TRACKER_SESSION_STORE_SOUND,
    payload: {
      soundObj: soundObj,
      soundLog: soundLog
    }
  };
};

// Start a ReadingTrackerPlayback session. Optional startTime in milliseconds.
var startTrackerPlaybackSessionV2 = function startTrackerPlaybackSessionV2() {
  var startTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return {
    type: SreReadingTracker.READING_TRACKER_PLAYBACK_START_V2,
    payload: {
      startTime: startTime
    }
  };
};

var seekTrackerPlaybackSessionTime = function seekTrackerPlaybackSessionTime(time) {
  return {
    type: SreReadingTracker.READING_TRACKER_PLAYBACK_SEEK_TIME,
    payload: {
      time: time
    }
  };
};

// Track the updates of a ReadinTrackerPlayback session.
var readingTrackerPlaybackProgress = function readingTrackerPlaybackProgress(progress) {
  var currentTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
  return {
    type: SreReadingTracker.READING_TRACKER_PLAYBACK_PROGRESS,
    payload: {
      progress: progress,
      currentTime: currentTime
    }
  };
};

// Interrupt a ReadinTrackerPlayback session. Invokes a saga cancellation.
var interruptTrackerPlaybackSession = function interruptTrackerPlaybackSession() {
  return {
    type: SreReadingTracker.READING_TRACKER_PLAYBACK_INTERRUPT
  };
};

// ReadinTrackerPlayback session end.
var readingTrackerPlaybackEnd = function readingTrackerPlaybackEnd() {
  return {
    type: SreReadingTracker.READING_TRACKER_PLAYBACK_END
  };
};

export default {
  startReadingTrackerSessionV2: startReadingTrackerSessionV2,
  readingTrackerSessionProgressV2: readingTrackerSessionProgressV2,
  readingTrackerSessionReset: readingTrackerSessionReset,
  readingTrackerSessionResultV2: readingTrackerSessionResultV2,
  readingTrackerSessionStoreSound: readingTrackerSessionStoreSound,
  startTrackerPlaybackSessionV2: startTrackerPlaybackSessionV2,
  readingTrackerPlaybackProgress: readingTrackerPlaybackProgress,
  interruptTrackerPlaybackSession: interruptTrackerPlaybackSession,
  readingTrackerPlaybackEnd: readingTrackerPlaybackEnd,
  seekTrackerPlaybackSessionTime: seekTrackerPlaybackSessionTime
};